import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import imgLogoText from '../../assets/images/logoText.png'
import iconSuccess from '../../assets/images/automatedTrafficFineNotificationSuccess.png'
import bannerTaxCds from '../../assets/images/bannertaxacds.png'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import BaseButton from '../../components/BasicComponent/BaseButton'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { PATH } from '../../constants/router'
import { number_to_price } from '../../helper/common'
import { RightOutlined, DownOutlined } from '@ant-design/icons'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { checkDurationUsageDate } from '../../components/FeaturesComponent/automatedTrafficFineNotificationServiceCard'
import { smartParseParam } from '../../helper/params'
import appUserService from '../../services/appUserService'
import {
  extractServicesAndVehiclesInOrderDetail,
  getTaxCdsPaymentVehiclesCache
} from '../../hooks/useAutomatedTrafficFineNotificationPayment'
import { CUSTOMER_RECEIPT_STATUS_TO_TEXT } from '../../constants/global'
import { ORDER_PAYMENT_STATUS_COLOR, PAYMENT_FAILED, PAYMENT_SUCCESS } from '../../constants/payment'
import { IS_TAX_CDS_MODE } from '../../constants/appMode'
import './index.scss'

export default function AutomatedTrafficFineNotificationSuccess() {
  const history = useHistory()
  const { id: orderId } = useParams()
  const [services, setServices] = useState([])
  const [vehicles, setVehicles] = useState([])
  const [orderDetail, setOrderDetail] = useState(null)

  const [showAllVehicles, setShowAllVehicles] = useState(false)
  const displayedVehicles = showAllVehicles ? vehicles : vehicles.slice(0, 1)

  const REACT_APP_MINIAPP_VIETTEL_MONEY = smartParseParam(process.env.REACT_APP_MINIAPP_VIETTEL_MONEY)

  const handleShareReceipt = async () => {
    const shareUrl = window.location.href

    if (navigator.share) {
      try {
        await navigator.share({
          title: IS_TAX_CDS_MODE ? 'TaxCDS - Thanh toán thành công' : 'Thanh toán thành công',
          url: shareUrl
        })
      } catch (error) {}

      return
    }

    try {
      await navigator.clipboard.writeText(shareUrl)
    } catch (error) {}
  }
  const orderStatus = CUSTOMER_RECEIPT_STATUS_TO_TEXT[orderDetail?.paymentStatus?.toUpperCase()] || ''
  const colorStatus = ORDER_PAYMENT_STATUS_COLOR.find((item) => item.value === orderDetail?.paymentStatus)?.color

  const orderStatusTitle = useMemo(() => {
    if (orderDetail?.paymentStatus === PAYMENT_SUCCESS) {
      return 'thành công'
    } else if (orderDetail?.paymentStatus === PAYMENT_FAILED) {
      return 'thất bại'
    } else {
      return ''
    }
  }, [orderDetail?.paymentStatus])

  const successImage = IS_TAX_CDS_MODE ? bannerTaxCds : iconSuccess
  const successContent = IS_TAX_CDS_MODE ? 'Mua gói Trợ lý thuế thông minh' : 'Mua gói thông báo phạt nguội'
  const successTitle = orderStatusTitle ? `${successContent} ${orderStatusTitle}` : successContent
  const successInfoLabel = IS_TAX_CDS_MODE ? 'Thông tin MST' : 'Thông tin xe'
  const successBackPath = IS_TAX_CDS_MODE ? PATH.TAX_CDS_SMART_ASSISTANT : PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SERVICES

  const TAX_CDS_DEV_HOME_URL = 'https://taxcds-tracuumst.service.makefamousapp.com/'
  const TAX_CDS_PROD_HOME_URL = 'https://miniapp-tracuuthongtinthue.tamove.vn/'

  const runtimeMode = process.env.REACT_APP_RUNTIME_MODE || 'production'

  const getTaxCdsHomeUrl = () => {
    return runtimeMode === 'developer' ? TAX_CDS_DEV_HOME_URL : TAX_CDS_PROD_HOME_URL
  }

  const handleGoHome = () => {
    if (IS_TAX_CDS_MODE) {
      window.location.href = getTaxCdsHomeUrl()
      return
    }

    history.push(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP)
  }

  const getSuccessVehicleInfo = (vehicle) => {
    const identity =
      vehicle?.taxCode ||
      vehicle?.mst ||
      vehicle?.citizenIdentityNumber ||
      vehicle?.identityNumber ||
      vehicle?.cccd ||
      vehicle?.plate ||
      vehicle?.vehicleIdentity ||
      '-'

    const name = vehicle?.taxpayerName || vehicle?.fullName || vehicle?.name || ''

    const address =
      vehicle?.businessAddress ||
      vehicle?.taxRegistrationAddress ||
      vehicle?.address ||
      ''

    return {
      identity,
      name,
      address
    }
  }

  const getSuccessVehicleDisplayValue = (vehicle) => {
    const vehicleInfo = getSuccessVehicleInfo(vehicle)

    if (!IS_TAX_CDS_MODE) {
      return vehicleInfo.identity
    }

    return (
      <div className="tax-success-payment-info">
        <div className="tax-success-payment-info__main">{vehicleInfo.identity}</div>

        {vehicleInfo.name ? (
          <div className="tax-success-payment-info__main">{vehicleInfo.name}</div>
        ) : null}

        {vehicleInfo.address ? (
          <div className="tax-success-payment-info__address">{vehicleInfo.address}</div>
        ) : null}
      </div>
    )
  }

    const getOrderDetailData = useCallback(async (orderId) => {
      try {
        const orderResult = await appUserService.getOrderDetail({ id: orderId })
        if (orderResult?.statusCode === 200 && orderResult?.data) {
          const orderDetail = orderResult.data
          setOrderDetail(orderDetail)
          const { services, vehicles } = extractServicesAndVehiclesInOrderDetail(orderDetail?.orderItems || [])
          const cachedTaxVehicles = IS_TAX_CDS_MODE ? getTaxCdsPaymentVehiclesCache(orderId) : []

          setServices(services)
          setVehicles(IS_TAX_CDS_MODE && cachedTaxVehicles.length > 0 ? cachedTaxVehicles : vehicles)
        }
      } catch (error) {}
    }, [])

  useEffect(() => {
    if (orderId) {
      getOrderDetailData(orderId)
    }
  }, [getOrderDetailData, orderId])

  return (
    <LayoutPartner>
      <div className="AutomatedTrafficFineNotificationSuccess">
        {(REACT_APP_MINIAPP_VIETTEL_MONEY || IS_TAX_CDS_MODE) && (
          <div className={`AutomatedTrafficFineNotificationSuccess_top ${IS_TAX_CDS_MODE ? 'is-tax-cds' : ''}`}>
            {IS_TAX_CDS_MODE ? <div className="AutomatedTrafficFineNotificationSuccess_taxLogo">TaxCDS</div> : <img src={imgLogoText} alt="" />}
            <span onClick={handleShareReceipt}>{IS_TAX_CDS_MODE ? 'Chia sẻ' : ''}</span>
          </div>
        )}
        <div className="AutomatedTrafficFineNotificationSuccess_image">
          <img src={successImage} alt="" />
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_total">
          <div className="total_label">{successTitle}</div>
          <div className="total_value">
            <strong>{number_to_price(orderDetail?.totalAmount || 0)}</strong>đ
          </div>
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_divider" />
        <div className="AutomatedTrafficFineNotificationSuccess_content">
         <div className="AutomatedTrafficFineNotificationSuccess_item">
          <div className="text_color_secondary">Nội dung</div>
          <div className="text_value">{successContent}</div>
        </div>
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Gói dịch vụ</div>
            <div className="text_value">{services[0]?.productName || '-'}</div>
          </div>
          {/* Thông tin xe */}
          {/* Thông tin thanh toán */}
          {displayedVehicles.map((vehicle, index) => {
            const vehicleInfo = getSuccessVehicleInfo(vehicle)

            if (!IS_TAX_CDS_MODE) {
              return (
                <div key={index} className="AutomatedTrafficFineNotificationSuccess_item">
                  <div className="text_color_secondary">
                    {successInfoLabel} {vehicles.length > 1 && (showAllVehicles || index > 0) ? `(${index + 1})` : ''}
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flex: 1 }}>
                    <span className="text_value">{vehicleInfo.identity}</span>

                    {vehicles.length > 1 &&
                      index === 0 &&
                      (showAllVehicles ? (
                        <DownOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(false)} />
                      ) : (
                        <RightOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(true)} />
                      ))}
                  </div>
                </div>
              )
            }

            return (
              <div key={index} className="AutomatedTrafficFineNotificationSuccess_item AutomatedTrafficFineNotificationSuccess_item--tax">
                <div className="text_color_secondary">
                  {successInfoLabel} {vehicles.length > 1 && (showAllVehicles || index > 0) ? `(${index + 1})` : ''}
                </div>

                <div className="AutomatedTrafficFineNotificationSuccess_valueWrap--tax">
                  <div className="text_value AutomatedTrafficFineNotificationSuccess_taxValue">
                    <div className="tax-success-payment-info">
                      <div className="tax-success-payment-info__main">{vehicleInfo.identity}</div>

                      {vehicleInfo.name ? <div className="tax-success-payment-info__main">{vehicleInfo.name}</div> : null}

                      {vehicleInfo.address ? <div className="tax-success-payment-info__address">{vehicleInfo.address}</div> : null}
                    </div>
                  </div>

                  {vehicles.length > 1 &&
                    index === 0 &&
                    (showAllVehicles ? (
                      <DownOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(false)} />
                    ) : (
                      <RightOutlined style={{ cursor: 'pointer', marginLeft: '8px' }} onClick={() => setShowAllVehicles(true)} />
                    ))}
                </div>
              </div>
            )
          })}
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Thời hạn</div>
            <div className="text_value">{checkDurationUsageDate(services[0]?.usageDate || 30)}</div>
          </div>
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_divider" />
        <div className="AutomatedTrafficFineNotificationSuccess_content">
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Số tiền</div>
            <div className="text_value">{number_to_price(orderDetail?.subTotalAmount || 0)}đ</div>
          </div>
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Thuế VAT (10%)</div>
            <div className="text_value">{number_to_price(orderDetail?.taxAmount || 0)}đ</div>
          </div>
          {orderDetail?.discountAmount > 0 && (
            <div className="AutomatedTrafficFineNotificationSuccess_item">
              <div className="text_color_secondary">Mã giảm giá</div>
              <div className="text_value">{number_to_price(orderDetail?.discountAmount || 0)}đ</div>
            </div>
          )}
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Tổng tiền thanh toán</div>
            <div className="text_value">{number_to_price(orderDetail?.totalAmount || 0)}đ</div>
          </div>
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_divider" />
        <div className="AutomatedTrafficFineNotificationSuccess_content">
          {REACT_APP_MINIAPP_VIETTEL_MONEY ? (
            <>
              <div className="AutomatedTrafficFineNotificationSuccess_item">
                <div className="text_color_secondary">Tài khoản thanh toán</div>
                <div className="text_bold text_value">ViettelPay</div>
              </div>
              <div className="AutomatedTrafficFineNotificationSuccess_item">
                <div className="text_color_secondary">Tài khoản nhận</div>
                <div className="text_bold text_value">Viễn thông</div>
              </div>
            </>
          ) : (
            <div className="AutomatedTrafficFineNotificationSuccess_item">
              <div className="text_color_secondary">Trạng thái</div>
              <div className="text_bold text_value" style={{ fontWeight: 'bold', color: colorStatus }}>
                {orderStatus}
              </div>
            </div>
          )}
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Mã giao dịch</div>
            <div className="text_bold text_value">{orderDetail?.orderCode || orderDetail?.orderData?.orderCode || '-'}</div>
          </div>
          <div className="AutomatedTrafficFineNotificationSuccess_item">
            <div className="text_color_secondary">Thời gian</div>
            <div className="text_bold text_value">
              {orderDetail?.updatedAt || orderDetail?.orderData?.updatedAt
                ? new Date(orderDetail?.updatedAt || orderDetail?.orderData?.updatedAt).toLocaleString('vi-VN')
                : '-'}
            </div>
          </div>
        </div>
        <div className="AutomatedTrafficFineNotificationSuccess_divider" />
        <FixedBottom elementPaddingBottom={'LayoutPartner'}>
          <BaseButton onClick={handleGoHome}>
            Về trang chủ
          </BaseButton>

          <div
            className="AutomatedTrafficFineNotificationSuccess_continue"
            onClick={() => {
              history.push(successBackPath)
            }}>
            Tiếp tục mua gói
          </div>
        </FixedBottom>
      </div>
    </LayoutPartner>
  )
}
